export default "__VITE_ASSET__fq_vI2yV__"